(() => {
  const host = window.location.hostname;
  if (!/(^|\.)saunamo\.es$/i.test(host)) return;

  const direct = [
    [/BAÑERAS DE HIELO/g, 'BAÑOS DE HIELO'],
    [/BAÑERA DE HIELO/g, 'BAÑO DE HIELO'],
    [/Baños de Hielo/g, 'Baños de Hielo'],
    [/Baño de Hielo/g, 'Baño de Hielo'],
    [/Las Baños de hielo/g, 'Los baños de hielo'],
    [/Los baños de hielo/g, 'Los baños de hielo'],
    [/los baños de hielo/g, 'los baños de hielo'],
    [/La Baño de hielo/g, 'El baño de hielo'],
    [/El baño de hielo/g, 'El baño de hielo'],
    [/el baño de hielo/g, 'el baño de hielo'],
    [/Una Baño de hielo/g, 'Un baño de hielo'],
    [/Un baño de hielo/g, 'Un baño de hielo'],
    [/un baño de hielo/g, 'un baño de hielo'],
    [/este baño de hielo/g, 'este baño de hielo'],
    [/Este baño de hielo/g, 'Este baño de hielo'],
    [/cada baño de hielo/g, 'cada baño de hielo'],
    [/Cada baño de hielo/g, 'Cada baño de hielo'],
    [/Baños de hielo/g, 'Baños de hielo'],
    [/Baño de hielo/g, 'Baño de hielo'],
    [/baños de hielo/g, 'baños de hielo'],
    [/baño de hielo/g, 'baño de hielo']
  ];

  const cleanup = [
    [/El baño de hielo/g, 'El baño de hielo'],
    [/el baño de hielo/g, 'el baño de hielo'],
    [/Un baño de hielo/g, 'Un baño de hielo'],
    [/un baño de hielo/g, 'un baño de hielo'],
    [/Los baños de hielo/g, 'Los baños de hielo'],
    [/los baños de hielo/g, 'los baños de hielo'],
    [/nuestros baños de hielo/g, 'nuestros baños de hielo'],
    [/Nuestros baños de hielo/g, 'Nuestros baños de hielo'],
    [/junto al baño de hielo/g, 'junto al baño de hielo'],
    [/Junto al baño de hielo/g, 'Junto al baño de hielo'],
    [/Cada baño de hielo/g, 'Cada baño de hielo'],
    [/cada baño de hielo/g, 'cada baño de hielo'],
    [/baños de hielo, hechos para ti/g, 'baños de hielo, hechos para ti'],
    [/cada baño de hielo está diseñado/g, 'cada baño de hielo está diseñado'],
    [/Cada baño de hielo está diseñado/g, 'Cada baño de hielo está diseñado'],
    [/cada baño de hielo está construido/g, 'cada baño de hielo está construido'],
    [/Cada baño de hielo está construido/g, 'Cada baño de hielo está construido'],
    [/los baños de hielo Saunamo están diseñados/g, 'los baños de hielo Saunamo están diseñados'],
    [/Los baños de hielo Saunamo están diseñados/g, 'Los baños de hielo Saunamo están diseñados'],
    [/los baños de hielo Saunamo están listos/g, 'los baños de hielo Saunamo están listos'],
    [/Los baños de hielo Saunamo están listos/g, 'Los baños de hielo Saunamo están listos'],
    [/Diseñados para quienes comprenden el poder del frío, los baños de hielo/g, 'Diseñados para quienes comprenden el poder del frío, los baños de hielo'],
    [/diseñadas para quienes comprenden el poder del frío, los baños de hielo/g, 'diseñados para quienes comprenden el poder del frío, los baños de hielo'],
    [/Diseñados para una colocación flexible, los baños de hielo/g, 'Diseñados para una colocación flexible, los baños de hielo'],
    [/diseñadas para una colocación flexible, los baños de hielo/g, 'diseñados para una colocación flexible, los baños de hielo'],
    [/Diseñados para una instalación sencilla, los baños de hielo/g, 'Diseñados para una instalación sencilla, los baños de hielo'],
    [/diseñadas para una instalación sencilla, los baños de hielo/g, 'diseñados para una instalación sencilla, los baños de hielo'],
    [/Construidos con materiales duraderos y sistemas de refrigeración/g, 'Construidos con materiales duraderos y sistemas de refrigeración'],
    [/construidas con materiales duraderos y sistemas de refrigeración/g, 'construidos con materiales duraderos y sistemas de refrigeración'],
    [/Baño de hielo ergonómico/g, 'Baño de hielo ergonómico'],
    [/baño de hielo ergonómico/g, 'baño de hielo ergonómico'],
    [/Baño de hielo instalado/g, 'Baño de hielo instalado'],
    [/baño de hielo instalado/g, 'baño de hielo instalado']
  ];

  function fixText(value) {
    if (!value || !/bañer|baño|BAÑER|BAÑO/i.test(value)) return value;
    let next = value;
    for (const [from, to] of direct) next = next.replace(from, to);
    for (const [from, to] of cleanup) next = next.replace(from, to);
    return next;
  }

  function fixNode(node) {
    if (node.nodeType === Node.TEXT_NODE) {
      const next = fixText(node.nodeValue);
      if (next !== node.nodeValue) node.nodeValue = next;
      return;
    }
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    if (/^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA|INPUT)$/i.test(node.tagName)) return;
    for (const attr of ['title', 'aria-label', 'alt']) {
      if (!node.hasAttribute(attr)) continue;
      const current = node.getAttribute(attr);
      const next = fixText(current);
      if (next !== current) node.setAttribute(attr, next);
    }
  }

  function run(root = document.body) {
    if (!root) return;
    fixNode(root);
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT | NodeFilter.SHOW_ELEMENT);
    while (walker.nextNode()) fixNode(walker.currentNode);
  }

  let pending = false;
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(() => {
      pending = false;
      run();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run(), { once: true });
  } else {
    run();
  }
  window.addEventListener('load', () => run(), { once: true });
  [300, 1500, 4000].forEach((ms) => window.setTimeout(run, ms));
  new MutationObserver(schedule).observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['title', 'aria-label', 'alt']
  });
})();